module.exports = __webpack_public_path__ + "img/jobSel.ae094079.svg";